import Select from "@/common/components/Select";
import { unitTranslation } from "@/common/constants/unitStrategies.contants";
import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const unitForConsumptionOptions = strategyToOptions(unitTranslation);

const DashboardFilterEquipmentCategoryUnitForConsumptionHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  return (
    <Select
      label="Selecione a métrica da categoria"
      markAsRequired
      options={unitForConsumptionOptions}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterEquipmentCategoryUnitForConsumptionHiddenFilter;
